import { render, staticRenderFns } from "./EditDepartment.vue?vue&type=template&id=508a01da&scoped=true"
import script from "./EditDepartment.vue?vue&type=script&lang=js"
export * from "./EditDepartment.vue?vue&type=script&lang=js"
import style0 from "./EditDepartment.vue?vue&type=style&index=0&id=508a01da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508a01da",
  null
  
)

export default component.exports